import React, { useState, useEffect } from 'react';
import Loading from '../components/Loading';
import { Link } from 'react-router-dom';
import WantUseClotereCard from "./WantUseClotereCard";
import { useParams } from 'react-router-dom';
import { Navbar } from '../Navbar.js';
import Footer from '../components/Footer';
import icnNotaire from '../img/icn-notaire.svg';
import axios from 'axios';
import { Helmet } from "react-helmet";
import { ChevronRightIcon, InformationCircleIcon, BoltIcon, TagIcon, CheckIcon, MapPinIcon, EnvelopeIcon, PhoneIcon, LinkIcon, ChatBubbleBottomCenterIcon } from '@heroicons/react/20/solid';
import CarteGoogleMaps from './CarteGoogleMap.js'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline'
import BackHeaderTop from "../components/BackHeaderTop";
import BackHeaderBottom from "../components/BackHeaderBottom";
import ContactNotaire from "./ContactNotaire"

const badgeColors = [
    'bg-indigo-200 text-indigo-800',
    'bg-purple-200 text-purle-800',
    'bg-blue-200 text-blue-800',
    'bg-green-200 text-green-800',
    'bg-yellow-200 text-yellow-800',
    'bg-gray-200 text-gray-800',
    'bg-red-200 text-red-800',

];
const actes = [
    { name: 'Compromis de vente' },
    { name: 'Acte de vente immobilière' },
    { name: 'Testament' },
    { name: 'Donation' },
    { name: 'Contrat de mariage' },
    { name: 'Pacte civil de solidarité (PACS)' },
    { name: 'Succession' },
    { name: 'Acte de notoriété' },
    { name: 'Mainlevée d’hypothèque' },
    { name: 'Rédaction de bail' },
    { name: 'Partage de biens' },
    { name: 'Liquidation de communauté' },
    { name: 'Changement de régime matrimonial' },
    { name: 'Contrat de société (SCI, SARL, etc.)' },
    { name: 'Cession de parts sociales' },
    { name: 'Acte d’achat de terrain' },
    { name: 'Acte de prêt ou de reconnaissance de dette' },
    { name: 'Servitude ou droit de passage' },
    { name: 'Acte de donation-partage' },
    { name: 'Inventaire après décès' },
    { name: 'Procès-verbal d’ouverture de testament' },
    { name: 'Vente en viager' },
    { name: 'Règlement de copropriété' },
    { name: 'Acte de vente aux enchères' },
    { name: 'Cession de fonds de commerce' }
];

const faqs = [
    {
        question: "Qu'est-ce qu'un notaire ?",
        answer:
            "Un notaire est un officier public nommé par l'État. Il est chargé de rédiger et d’authentifier des actes juridiques ayant une valeur légale, comme les ventes immobilières, les successions ou les contrats de mariage.",
    },
    {
        question: "Quand faire appel à un notaire ?",
        answer:
            "Il est recommandé de consulter un notaire pour les ventes immobilières, les donations, les testaments, les mariages ou encore les créations d'entreprise. Certains actes exigent obligatoirement son intervention.",
    },
    {
        question: "Les services d’un notaire sont-ils payants ?",
        answer:
            "Oui. Les frais notariés incluent les taxes reversées à l'État, les frais de débours et les émoluments du notaire. Ces frais sont réglementés.",
    },
    {
        question: "Puis-je choisir mon notaire librement ?",
        answer:
            "Oui, chacun est libre de choisir son notaire. Lors d’une transaction, acheteur et vendeur peuvent même être assistés par leurs propres notaires, sans frais supplémentaires.",
    },
    {
        question: "Quelle est la valeur juridique d’un acte notarié ?",
        answer:
            "Un acte authentique signé devant notaire a une valeur probante et exécutoire. Il fait foi jusqu’à preuve du contraire, ce qui en fait un document très sécurisé.",
    },
    {
        question: "Un notaire peut-il me conseiller ?",
        answer:
            "Oui. Le notaire a un devoir d’information et de conseil impartial. Il s’assure que toutes les parties comprennent les enjeux juridiques et fiscaux des actes signés.",
    },
    {
        question: "Comment trouver un notaire près de chez moi ?",
        answer:
            "Vous pouvez utiliser notre annuaire en ligne pour rechercher un notaire par ville ou région, et filtrer selon la spécialité ou les services proposés.",
    }
];

function FicheNotaire(args) {
    const [notaire, setNotaire] = useState(null);
    const [isLoading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    //on retrouve le notaire
    const { nom } = useParams();

    const SPREADSHEET_ID = '1goMuEIM_a2g9k0jivUC4t0ABw5ABLaX1QSLvJwnGlgk';
    const API_KEY = 'AIzaSyDOypSeMIO3bhhlZt9-2KZ7OKpQW1n-njg';
    const RANGE = 'France';

    //recuperation data google sheet
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${RANGE}?key=${API_KEY}`
                );
                const rows = response.data.values;
                //console.log("ici", rows);
                setData(rows);
            } catch (error) {
                console.error('Error fetching data: ', error);
            }
        };

        fetchData();

    }, []);

    //recuperation data airtable
    useEffect(() => {
        if (data.length > 1) {
            const headers = data[0];
            const rows = data.slice(1);
            const formatted = rows.map(row => {
                const obj = {};
                headers.forEach((header, index) => {
                    obj[header] = row[index] || '';
                });
                return obj;
            });


            if (formatted != null) {
                var filteredData = formatted.filter(item => item.lien_fiche === nom);

                if (filteredData.length > 0) {
                    if (filteredData[0].id_airtable !== null) {
                        const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/user/${filteredData[0].id_airtable}`;

                        fetch(
                            URL,
                            {
                                method: "GET",
                                headers: {
                                    Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
                                    'content-type': 'application/x-www-form-urlencoded',
                                    "Accept": "application/json, text/plain, /"
                                },
                            })
                            .then((res) => res.json())
                            .then((res) => {
                                var notaireAirtable = res.fields;
                                console.log("res", res);
                                setNotaire({ ...notaireAirtable, ...filteredData[0] });

                            })
                            .catch((error) => console.log(error));
                    }
                }
            }
        }
    }, [data]);


    useEffect(() => {
        console.log(notaire);
        if (notaire != null) {
            setLoading(false);
        }
    }, [notaire]);


    


    if (isLoading) {
        return <Loading />;
    }
    return (
        <>
            <Helmet>
                <title>Maitre {notaire.nom} - notaire à {notaire.ville}</title>
            </Helmet>
            <div className="relative bg-gradient-to-b from-transparent to-purple-50">
                <BackHeaderTop />
                <Navbar
                    user={args.user}
                />
                <div className='container pb-16'>
                    <nav aria-label="Breadcrumb" className="flex my-6">
                        <ol className="flex items-center space-x-4 pl-0 mb-0">
                            <li>
                                <div>
                                    <Link to="/trouver-votre-notaire" className="text-xs text-black font-bold no-underline hover:text-indigo-500 ">
                                        Annuaire des notaires
                                    </Link>
                                </div>
                            </li>
                            <li>
                                <div className="flex items-center">
                                    <ChevronRightIcon aria-hidden="true" className="size-5 shrink-0 text-gray-400" />
                                    <Link
                                        to={`/trouver/notaires/${notaire.ville}`}
                                        className="ml-4 text-xs  text-black font-bold no-underline hover:text-indigo-5000"
                                    >
                                        Notaires à {notaire.ville}
                                    </Link>
                                </div>
                            </li>
                            <li>
                                <div className="flex items-center">
                                    <ChevronRightIcon aria-hidden="true" className="size-5 shrink-0 text-gray-400" />
                                    <p
                                        className="m-0 ml-4 text-xs font-base text-gray-800 hover:text-gray-700 no-underline"
                                    >
                                        {notaire.nom}
                                    </p>
                                </div>
                            </li>
                        </ol>
                    </nav>
                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 relative">

                        {/** SIDEBAR FICHE  */}
                        <div className='sm:!sticky  transition-all duration-300 top-5'>
                            {/**card notaire */}
                            <ul className="relative pl-0">
                                <li className="col-span-1 flex flex-col divide-y divide-gray-200 rounded-lg bg-white text-center shadow-sm">
                                    <div className="flex flex-1 flex-col p-8">
                                        {notaire.photo_profil_from_notaire ? <>
                                            <img className="mx-auto size-40 shrink-0 rounded-full" src={notaire.photo_profil_from_notaire[0].url} alt={notaire.nom} />
                                        </> : <>
                                            <img className="mx-auto size-20 shrink-0 rounded-full" src={icnNotaire} alt="notaire" />
                                        </>}
                                        <h1 className="mt-6 text-2xl font-medium text-gray-900">Maître {notaire.nom}</h1>
                                        <dl className="mt-1 flex grow flex-col justify-between">
                                            <dd className="text-base text-gray-500">Notaire à {notaire.ville}</dd>
                                            <dd className="mt-3">
                                                {notaire.utilise_clotere === "oui" ? <>

                                                    <div className="flex flex-col gap-2 mb-2">
                                                        <span className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-100 px-3 py-2 text-sm font-medium text-indigo-600 my-1">
                                                            <svg viewBox="0 0 6 6" aria-hidden="true" className="size-3 fill-indigo-400">
                                                                <circle r={3} cx={3} cy={3} />
                                                            </svg>
                                                            Notaire recommandé
                                                        </span>
                                                        <span className="inline-flex items-center gap-x-1.5 rounded-md bg-purple-100 px-3 py-2 text-sm font-medium text-purple-600 my-1">
                                                            <svg viewBox="0 0 6 6" aria-hidden="true" className="size-4 fill-purple-400">
                                                                <BoltIcon />
                                                            </svg>
                                                            Réponds rapidement
                                                        </span>
                                                    </div>
                                                </> : <>
                                                    <span className="inline-flex items-center gap-x-1.5 rounded-md bg-gray-100 px-1.5 py-0.5 text-sm font-medium text-gray-600 my-1">
                                                        Notaire
                                                    </span>
                                                </>}
                                            </dd>
                                        </dl>
                                    </div>

                                </li>
                                {notaire.utilise_clotere === "non" && <>
                                    <WantUseClotereCard nom={notaire.nom} />
                                </>}
                            </ul>
                        </div>

                        {/** CONTENT FICHE  */}
                        <div className='col-span-2'>
                            {notaire.utilise_clotere === "oui" ? <>

                                {/** contact */}
                                <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm">
                                    <div className="p-4 flex items-center gap-2">
                                        <ChatBubbleBottomCenterIcon className='inline-flex text-indigo-200 size-8' />
                                        <h3 className="text-base font-semibold text-gray-900 mb-0">Contacter Maître {notaire.nom}</h3>
                                    </div>
                                    <div className="p-4">
                                        <ContactNotaire abonnement={notaire.stripe_abonnement} id={notaire.id_airtable} nom={notaire.nom}/>
                                    </div>
                                </div>
                                {/** presentation */}
                                <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm mt-8">
                                    <div className="p-4 flex items-center gap-2">
                                        <InformationCircleIcon className='inline-flex text-indigo-200 size-8' />
                                        <h3 className="text-base font-semibold text-gray-900 mb-0">Présentation</h3>
                                    </div>
                                    <div className="p-4">
                                        <p className='mb-0'>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: notaire.presentation_from_notaire
                                                }}></div>
                                        </p>
                                    </div>
                                </div>

                                {/** coordonnées */}
                                <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm mt-8">
                                    <div className="p-4 flex items-center gap-2">
                                        <MapPinIcon className='inline-flex text-indigo-200 size-8' />
                                        <h3 className="text-base font-semibold text-gray-900 mb-0">Coordonnées</h3>
                                    </div>
                                    <div className="p-4">
                                        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            <div>
                                                <ul className="divide-y divide-gray-100 p-0">
                                                    <li className="flex flex-col justify-start gap-3 py-3">
                                                        <p className='text-lg font-bold mb-0'>Maître {notaire.nom}</p>
                                                        <div className='flex flex-row gap-2 items-center justify-start'>
                                                            <MapPinIcon className=' inline-flex size-4 text-slate-600' />
                                                            {notaire.adresse}, {notaire.cp}, {notaire.ville}
                                                        </div>

                                                    </li>
                                                    <br />

                                                    <li className="flex flex-col justify-start gap-3 py-3">
                                                        <div className='flex flex-row gap-2 items-center justify-start'>
                                                            <EnvelopeIcon className=' inline-flex size-4 text-slate-600' />
                                                            {notaire.email}
                                                        </div>
                                                    </li>

                                                    <li className="flex flex-col justify-start gap-3 py-3">
                                                        <div className='flex flex-row gap-2 items-center justify-start'>
                                                            <PhoneIcon className=' inline-flex size-4 text-slate-600' />
                                                            {notaire.telephone}
                                                        </div>
                                                    </li>

                                                    <li className="flex flex-col justify-start gap-3 py-3">
                                                        <div className='flex flex-row gap-2 items-center justify-start'>
                                                            <LinkIcon className=' inline-flex size-4 text-slate-600' />
                                                            <a href={notaire.site} target="blank">
                                                                {notaire.site}
                                                            </a>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div>
                                                <CarteGoogleMaps
                                                    adresse={notaire.adresse}
                                                    ville={notaire.cp} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/** domaine de compentes */}
                                <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm mt-8">
                                    <div className="p-4 flex items-center gap-2">
                                        <TagIcon className='inline-flex text-indigo-200 size-8' />
                                        <h3 className="text-base font-semibold text-gray-900 mb-0">Domaines de compétences</h3>
                                    </div>
                                    <div className="p-4">
                                        {notaire.domaine_competences_from_notaire.length > 0 && (
                                            <>
                                                {notaire.domaine_competences_from_notaire.map((col, i) => {
                                                    const shuffledColors = [...badgeColors].sort(() => 0.5 - Math.random());
                                                    const colorClass = shuffledColors[i % shuffledColors.length]; // Assure qu’on ne dépasse pas
                                                    return (
                                                        <span key={i} className={`inline-flex items-center rounded-md  px-3 py-2 text-sm font-medium m-2 ${colorClass}`}>
                                                            {col}
                                                        </span>
                                                    );
                                                })}
                                            </>
                                        )}
                                        <p className='my-4 text-base font-bold'>Actes notariés réalisés</p>
                                        {actes.map((col, i) => {
                                            return (
                                                <span className="m-2 inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">
                                                    {col.name}
                                                </span>
                                            );
                                        })}
                                    </div>
                                </div>

                                {/** services */}
                                <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm mt-8">
                                    <div className="p-4 flex items-center gap-2">
                                        <InformationCircleIcon className='inline-flex text-indigo-200 size-8' />
                                        <h3 className="text-base font-semibold text-gray-900 mb-0">Services proposés</h3>
                                    </div>
                                    <div className="p-4">
                                        <p>	Le notaire accompagne particuliers et professionnels dans leurs démarches juridiques, notamment en matière d’immobilier, de succession, de mariage et d’entreprise, en garantissant des actes authentiques et sécurisés.</p>

                                        <ul className="divide-y divide-gray-100 p-0">
                                            {notaire.visio_from_info_notaire &&
                                                <>
                                                    <li className="flex justify-start gap-x-6 py-2">
                                                        <CheckIcon className='size-6 text-green-600' />
                                                        Réunion en visio-conférence
                                                    </li>
                                                </>
                                            }
                                            {notaire.whatsapp_from_info_notaire &&
                                                <>
                                                    <li className="flex justify-start gap-x-6 py-2">
                                                        <CheckIcon className='size-6 text-green-600' />
                                                        Échange via whatsapp
                                                    </li>
                                                </>
                                            }
                                            {notaire.signature_from_info_notaire &&
                                                <>
                                                    <li className="flex justify-start gap-x-6 py-2">
                                                        <CheckIcon className='size-6 text-green-600' />
                                                        Signature en ligne
                                                    </li>
                                                </>
                                            }

                                        </ul>

                                    </div>
                                </div>




                                {/** rôle */}
                                <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm mt-8">
                                    <div className="p-4 flex items-center gap-2">
                                        <InformationCircleIcon className='inline-flex text-indigo-200 size-8' />
                                        <h3 className="text-base font-semibold text-gray-900 mb-0">Rôle de votre notaire</h3>
                                    </div>
                                    <div className="p-4">
                                        <p className='mb-0'>
                                            Maître {notaire.nom}, est notaire situé à {notaire.adresse}, et exerce un rôle essentiel dans la sécurité juridique des actes de la vie quotidienne.
                                            <br /><br />
                                            Officier public nommé par l’État, le notaire est habilité à rédiger des actes authentiques ayant une valeur légale incontestable.
                                        </p>
                                        <p>
                                            Que ce soit pour <b>l’achat d’un bien immobilier</b>, l’<b>organisation d’une succession</b> ou la <b>signature d’un contrat de mariage</b>, Maître {" "}
                                            {notaire.nom} conseille ses clients de manière impartiale et veille à la conformité juridique des documents.
                                            <br /><br />Son étude, basée à {notaire.adresse},
                                            accueille les particuliers comme les professionnels pour les accompagner dans toutes les étapes importantes de leur vie.
                                        </p>
                                    </div>
                                </div>

                                {/** FAQ notaire */}
                                <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm mt-8">
                                    <div className="p-4 flex items-center gap-2">
                                        <InformationCircleIcon className='inline-flex text-indigo-200 size-8' />
                                        <h3 className="text-base font-semibold text-gray-900 mb-0">Questions fréquentes au sujet des notaires</h3>
                                    </div>
                                    <div className="p-4">
                                        <div className="bg-white">
                                            <dl className="divide-y divide-gray-900/10">
                                                {faqs.map((faq) => (
                                                    <Disclosure key={faq.question} as="div" className="py-6 first:pt-0 last:pb-0">
                                                        <dt>
                                                            <DisclosureButton className="group flex w-full items-start justify-between text-left text-gray-900">
                                                                <span className="text-base/7 font-semibold">{faq.question}</span>
                                                                <span className="ml-6 flex h-7 items-center">
                                                                    <PlusSmallIcon aria-hidden="true" className="size-6 group-data-open:hidden" />
                                                                    <MinusSmallIcon aria-hidden="true" className="size-6 group-not-data-open:hidden" />
                                                                </span>
                                                            </DisclosureButton>
                                                        </dt>
                                                        <DisclosurePanel as="dd" className="mt-2 pr-12">
                                                            <p className="text-base/7 text-gray-600">{faq.answer}</p>
                                                        </DisclosurePanel>
                                                    </Disclosure>
                                                ))}
                                            </dl>
                                        </div>

                                    </div>
                                </div>
                            </> : <>

                                <div className="rounded-md bg-blue-50 p-4 ">
                                    <div className="flex">
                                        <div className="flex-shrink-0">
                                            <InformationCircleIcon aria-hidden="true" className="h-5 w-5 text-blue-400" />
                                        </div>
                                        <div className="ml-3 flex-1 md:flex md:justify-between">
                                            <p className="text-sm text-blue-700 mb-0">Ce notaire n'utilise pas Clotere, vous ne pouvez pas le contacter ici </p>

                                        </div>
                                    </div>
                                </div>
                                {/** coordonnées */}
                                <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm mt-8">
                                    <div className="p-4 flex items-center gap-2">
                                        <MapPinIcon className='inline-flex text-indigo-200 size-8' />
                                        <h3 className="text-base font-semibold text-gray-900 mb-0">Coordonnées</h3>
                                    </div>
                                    <div className="p-4">
                                        <div>
                                            <ul className="divide-y divide-gray-100 p-0">
                                                <li className="flex flex-col justify-start gap-3 py-3">
                                                    <p className='text-lg font-bold mb-0'>Maître {notaire.nom}</p>
                                                    <div className='flex flex-row gap-2 items-center justify-start'>
                                                        <MapPinIcon className=' inline-flex size-4 text-slate-600' />
                                                        {notaire.adresse}, {notaire.cp}, {notaire.ville}
                                                    </div>

                                                </li>
                                                <li className="flex flex-col justify-start gap-3 py-3">
                                                    <div className='flex flex-row gap-2 items-center justify-start'>
                                                        <LinkIcon className=' inline-flex size-4 text-slate-600' />
                                                        <a href={notaire.site} target="blank">
                                                            {notaire.site}
                                                        </a>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/** rôle */}
                                <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm mt-8">
                                    <div className="p-4 flex items-center gap-2">
                                        <InformationCircleIcon className='inline-flex text-indigo-200 size-8' />
                                        <h3 className="text-base font-semibold text-gray-900 mb-0">Rôle de votre notaire</h3>
                                    </div>
                                    <div className="p-4">
                                        <p className='mb-0'>
                                            Maître {notaire.nom}, est notaire situé à {notaire.adresse}, et exerce un rôle essentiel dans la sécurité juridique des actes de la vie quotidienne.
                                            <br /><br />
                                            Officier public nommé par l’État, le notaire est habilité à rédiger des actes authentiques ayant une valeur légale incontestable.
                                        </p>
                                        <p>
                                            Que ce soit pour <b>l’achat d’un bien immobilier</b>, l’<b>organisation d’une succession</b> ou la <b>signature d’un contrat de mariage</b>, Maître
                                            {notaire.nom} conseille ses clients de manière impartiale et veille à la conformité juridique des documents.
                                            <br /><br />Son étude, basée à {notaire.adresse},
                                            accueille les particuliers comme les professionnels pour les accompagner dans toutes les étapes importantes de leur vie.
                                        </p>
                                    </div>
                                </div>


                            </>}



                        </div>
                    </div>
                </div>
                <div className='relative'>
                    <BackHeaderBottom />
                </div>
                <Footer />
            </div>
        </>

    );
}

export default FicheNotaire;